import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class RecTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "settingColumn", title: "Settings" },
        { name: "optionColumn", title: "Recommended" },
        { name: "descriptionColumn", title: "Description" }
      ],
      rows: [
        { settingColumn: 'Video Encoder', optionColumn: 'Auto', descriptionColumn: 'The video writer. Shinobi will try to choose the best option for you when selecting Auto. For Manual Selection :  RTSP cameras will generally take copy. MJPEG cameras will take libx264.' },
        { settingColumn: 'Audio Encoder', optionColumn: 'No Audio', descriptionColumn: 'RTSP cameras will generally use aac. MJPEG cameras must be set to No Audio.' },
        { settingColumn: 'Segment Length', optionColumn: '2', descriptionColumn: 'Set this to 2 for a buffer of ~5 seconds.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

RecTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(RecTable)